var render, staticRenderFns
var script = {}
import style0 from "./style.vue?vue&type=style&index=0&id=2092f872&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092f872",
  null
  
)

export default component.exports